var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "avatar-container right-menu-item hover-effect",
      attrs: { trigger: "click" },
    },
    [
      _c("div", { staticClass: "avatar-wrapper" }, [
        _c("img", {
          staticClass: "user-avatar",
          attrs: {
            src: "https://jy-material.jingyougz.com/local_material/image/2025-02-19/8dff49985d0d8afa53751d9ba8907aed.png",
          },
        }),
        _vm._v(" "),
        _c("i", { staticClass: "el-icon-caret-bottom" }),
      ]),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c("el-dropdown-item", [_vm._v(_vm._s(_vm.username))]),
          _vm._v(" "),
          _c("el-dropdown-item", { attrs: { divided: "" } }, [
            _c("div", { on: { click: _vm.changePasswordClick } }, [
              _vm._v("修改密码"),
            ]),
          ]),
          _vm._v(" "),
          _c("el-dropdown-item", { attrs: { divided: "" } }, [
            _c(
              "span",
              { staticStyle: { display: "block" }, on: { click: _vm.logout } },
              [_vm._v(_vm._s(_vm.$t("navbar.logOut")))]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("ChangePasswordDialog", {
        ref: "ChangePasswordDialog",
        on: { success: _vm.logout },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }